<template>
  <div>
    <div class="card">
      <div class="card-header"><h4>Cadastrar Jogo</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome"
              v-model="state.jogo.nome.value"
            />
            <span v-if="state.jogo.nome.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="desc">Link Android</label>
            <input
              id="desc"
              type="email"
              class="form-control"
              placeholder="Link"
              v-model="state.jogo.link_android.value"
            />
            <span v-if="state.jogo.link_android.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="desc">Link IOS</label>
            <input
              id="desc"
              type="email"
              class="form-control"
              placeholder="Link"
              v-model="state.jogo.link_ios.value"
            />
            <span v-if="state.jogo.link_ios.error" class="text-danger"
              >Este campo é obrigatório</span
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="status">Status</label>
            <select v-model="state.jogo.status" class="form-select">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
        <div class="btns_right">
          <button @click="salvarCat" type="button" class="btn_save">
            Salvar
          </button>
          <router-link to="/jogos">
            <button type="button" class="btn_cancel">Cancelar</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      jogo: {
        nome: {
          value: "",
          error: false,
        },
        link_android: {
          value: "",
          error: false,
        },
        link_ios: {
          value: "",
          error: false,
        },
        status: "ATIVO",
      },
    });
    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetch();
      }
    });
    async function fetch() {
      try {
        const { data } = await services.jogos_educativos.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.jogo.id = data.id;
        state.jogo.nome.value = data.nome;
        state.jogo.link_android.value = data.link_android;
        state.jogo.link_ios.value = data.link_ios;
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarCat() {
      var erro_validacao = false;

      if (state.jogo.nome.value.length == 0) {
        state.jogo.nome.error = true;
        erro_validacao = true;
      }
      if (state.jogo.link_android.value.length == 0) {
        state.jogo.link_android.error = true;
        erro_validacao = true;
      }
      if (state.jogo.link_ios.value.length == 0) {
        state.jogo.link_ios.error = true;
        erro_validacao = true;
      }
      if (erro_validacao == true) {
        return;
      }
      if (!state.jogo.id) {
        await services.jogos_educativos
          .save({
            status: state.jogo.status,
            nome: state.jogo.nome.value,
            link_ios: state.jogo.link_ios.value,
            link_android: state.jogo.link_android.value,
            token,
          })
          .then((data) => {
            console.log(data);
            router.push({ name: "Jogos" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      } else {
        await services.jogos_educativos
          .update({
            id: state.jogo.id,
            status: state.jogo.status,
            nome: state.jogo.nome.value,
            link_ios: state.jogo.link_ios.value,
            link_android: state.jogo.link_android.value,
            token,
          })
          .then((data) => {
            console.log(data);
            router.push({ name: "Jogos" });
          })
          .catch((error) => {
            console.log(error);
            var valores = Object.values(error.response.data.errors);
            alert(valores);
          });
      }
    }
    async function adicionarThumbnail(event) {
      var thumb = event.target.files[0];
      var objThumb = new Object();
      objThumb.file = thumb;
      objThumb.thumbnail = URL.createObjectURL(thumb);
      state.thumbnail = objThumb;
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];

      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerThumbnail() {
      state.thumbnail = {};
      document.querySelector('input[type="file"]').value = null;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarCat,
      removerImagem,
      removerThumbnail,
      adicionarImagem,
      adicionarThumbnail,
      router,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #47b0a9;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #47b0a9;
}
.btns_right {
  text-align: right;
  margin-top: 1rem;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
textarea {
  resize: none;
  border: solid 1px #000;
}
textarea:focus {
  border: solid 1px #47b0a9;
}
#pills-home-tab {
  color: #000;
}
#pills-home-tab:focus {
  color: #47b0a9;
}
#pills-profile-tab {
  color: #000000;
}
#pills-profile-tab:focus {
  color: #47b0a9;
}
.btn-add {
  color: #000;
  padding: 5px;
  width: 100px;
  background: orange;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn-add:hover {
  background: rgb(208, 135, 1);
  color: #000;
}
tr {
  border-bottom: solid 1px rgb(0, 0, 0);
}
thead {
  color: #000;
  text-align: center;
  background: gray;
}
td {
  color: #000;
  text-align: center;
}
.table {
  margin-top: 2rem;
}
.imagem {
  width: 100%;
  height: auto;
  -o-object-fit: cover;
  object-fit: cover;
  margin-top: 2rem;
  border: solid 2px #4bafa9;
}
.btn_deletar_imagem {
  margin-left: 10px;
  height: 30px;
  width: 30px;
  margin-top: 2rem;
  background: #c4342d;
  color: #000;
  border: solid 1px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_deletar_imagem:hover {
  background: #8f0303;
  border: solid 1px #000;
}
</style>